(function($) {
    $.fn.radioCardSelect = function(options) {
        // Default settings
        const settings = $.extend({
            cardSelector: '.custom-radio-div',
            radioSelector: 'input[type="radio"]',
            selectedClass: 'selected'
        }, options);

        // Initialize plugin
        return this.each(function() {
            const $container = $(this);

            // Handle click on card
            $container.on('click', settings.cardSelector, function(e) {
                // Don't trigger if clicking directly on the radio input
                if ($(e.target).is(settings.radioSelector) || $(e.target).closest(settings.radioSelector).length) {
                    return;
                }

                const $card = $(this);
                const $radio = $card.find(settings.radioSelector);

                // Select the radio button and add class
                $radio.prop('checked', true).trigger('change');
                $container.find(settings.cardSelector).removeClass(settings.selectedClass);
                $card.addClass(settings.selectedClass);
            });

            // Handle change on radio button directly
            $container.on('change', settings.radioSelector, function() {
                const $radio = $(this);
                const $card = $radio.closest(settings.cardSelector);

                $container.find(settings.cardSelector).removeClass(settings.selectedClass);
                $card.addClass(settings.selectedClass);
            });

            // Initialize selected state
            $container.find(`${settings.radioSelector}:checked`)
                    .closest(settings.cardSelector)
                    .addClass(settings.selectedClass);
        });
    };
}(jQuery));
